class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Mega Menu functionality
class MegaMenuController {
  constructor() {
    this.menuItems = [];
    this.hoverTimeout = null;
    this.hoverDelay = 150;
    
    this.init();
  }

  init() {
    const triggers = document.querySelectorAll('.mega-menu-trigger');
    
    triggers.forEach(trigger => {
      const panelId = trigger.getAttribute('data-mega-menu-id');
      const panel = document.querySelector(`[data-mega-menu-panel="${panelId}"]`);
      
      if (!panel) {
        console.warn(`Panel not found for trigger with id: ${panelId}`);
        return;
      }
      
      // Store the pair
      this.menuItems.push({ trigger, panel, panelId });
      
      // Hover events for desktop
      if (window.innerWidth >= 990) {
        trigger.addEventListener('mouseenter', () => {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = setTimeout(() => {
            this.showPanel(trigger, panel);
          }, this.hoverDelay);
        });
        
        trigger.addEventListener('mouseleave', (e) => {
          clearTimeout(this.hoverTimeout);
          if (!panel.contains(e.relatedTarget)) {
            this.hoverTimeout = setTimeout(() => {
              this.hidePanel(trigger, panel);
            }, this.hoverDelay);
          }
        });
        
        panel.addEventListener('mouseenter', () => {
          clearTimeout(this.hoverTimeout);
        });
        
        panel.addEventListener('mouseleave', (e) => {
          if (!trigger.contains(e.relatedTarget)) {
            clearTimeout(this.hoverTimeout);
            this.hoverTimeout = setTimeout(() => {
              this.hidePanel(trigger, panel);
            }, this.hoverDelay);
          }
        });
      }
      
      // Click event for toggle behavior
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (panel.hasAttribute('hidden')) {
          this.showPanel(trigger, panel);
        } else {
          this.hidePanel(trigger, panel);
        }
      });
    });
    
    console.log(`MegaMenuController initialized with ${this.menuItems.length} menu items`);
    
    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mega-menu-trigger') && !e.target.closest('.mega-menu-panel')) {
        this.hideAllPanels();
      }
    });
  }

  showPanel(trigger, panel) {
    // Hide any currently active panel
    this.hideAllPanels();
    
    // Show the new panel
    panel.removeAttribute('hidden');
    trigger.setAttribute('aria-expanded', 'true');
    
    // Set header bottom position if needed
    const header = document.querySelector('.header-wrapper');
    if (header && document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  hidePanel(trigger, panel) {
    panel.setAttribute('hidden', '');
    trigger.setAttribute('aria-expanded', 'false');
  }

  hideAllPanels() {
    this.menuItems.forEach(({ trigger, panel }) => {
      if (!panel.hasAttribute('hidden')) {
        this.hidePanel(trigger, panel);
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenuController();
  });
} else {
  new MegaMenuController();
}
